import * as _ from "lodash"

import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_EventAccrualRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";
import {CustomerSearch} from "./CustomerSearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";


const vWB_Snapshot_Accrual_Brand_Fields: {[id:string]: ISearchProviderField } = {
    WB_GLACCT_ID:                 {type: SearchProviderFieldType.number, renderOptions: { columnName: 'GL Account WB Id',    columnResourceName: 'colGLAcctWBId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PILLAR_ID:                    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Pillar ID',    columnResourceName: 'colPillarId', alignment: HorizAlignment.Left}, domainOptions: {}},
    PILLAR_NAME:                  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Pillar',        columnResourceName: 'colPillarName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    BRAND_ID:                     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Brand ID',        columnResourceName: 'colBrandId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    BRAND_NAME:                   {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Brand', columnResourceName: 'colBrandName', alignment: HorizAlignment.Left}, domainOptions: {profileId: "SnapshotAccrualBrandSearchByListSearchProfile", bUseSearchProvidersDistinctValues: true}},
    TOTAL_YTD_LIABILITY:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'YTD Total Liability',        columnResourceName: 'colYTDTotalLiability', alignment: HorizAlignment.Right, numberFormat: "#,##0.000"}, domainOptions: { maxLength: 50}},
    PREVIOUS_TOTAL_YTD_LIABILITY: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Previous Period YTD Total Liability',        columnResourceName: 'colYTDTotalLiability', alignment: HorizAlignment.Right, numberFormat: "#,##0.000"}, domainOptions: { maxLength: 50}},
    CHANGE_TOTAL_YTD_LIABILITY:   {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Period Change in YTD Total Liability',        columnResourceName: 'colYTDTotalLiability', alignment: HorizAlignment.Right, numberFormat: "#,##0.000"}, domainOptions: { maxLength: 50}},
    CURRENT_SNAPSHOT_ID:          {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Current Snapshot WB Id',    columnResourceName: 'colCurrSnapshotWBId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PREVIOUS_SNAPSHOT_ID:         {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Previous Snapshot WB Id',    columnResourceName: 'colPrevSnapshotWBId', alignment: HorizAlignment.Center}, domainOptions: {}},
    GLACCOUNT_NAME:               {type: SearchProviderFieldType.string, renderOptions: {columnName: 'GL Account', columnResourceName: 'colGLAccount', alignment: HorizAlignment.Left}, domainOptions: { }}
}

const vWB_Snapshot_Accrual_Brand_KeyFields =
    {id:    'BRAND_ID',
        id_ui: 'BRAND_ID',
        name:  'BRAND_NAME'}


class SnapshotAccrualBrandSearchByListSearchProvider
    implements  ISearchProvider {

    wbSnapshotIdCurr:number = 0
    wbSnapshotIdPrev:number = 0
    _searchProviderFields: {[id:string]: ISearchProviderField } = {}

    constructor(WB_Snapshot_Id_Curr: number, WB_Snapshot_Id_Prev: number, aSearch: ISearch){
        this.wbSnapshotIdCurr = WB_Snapshot_Id_Curr
        this.wbSnapshotIdPrev = WB_Snapshot_Id_Prev
        this._searchProviderFields = _.cloneDeep(vWB_Snapshot_Accrual_Brand_Fields)
        this.searchProviderFields.BRAND_NAME.domainOptions.search = aSearch
    }

    get keyFields() { return vWB_Snapshot_Accrual_Brand_KeyFields }

    get searchProviderFields(){
        return vWB_Snapshot_Accrual_Brand_Fields
    }

    search(requestSpec: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            debugger
            requestSpec.where.CURRENT_SNAPSHOT_ID = this.wbSnapshotIdCurr
            requestSpec.where.PREVIOUS_SNAPSHOT_ID = this.wbSnapshotIdPrev

            let findRequest = SearchUtils.makeSearchRequest(requestSpec,
                'vUI_Snapshot_Accrual_YTD_Compare',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({"where": {"CURRENT_SNAPSHOT_ID": this.wbSnapshotIdCurr, "PREVIOUS_SNAPSHOT_ID": this.wbSnapshotIdPrev}},
                'vUI_Snapshot_Accrual_YTD_Compare',
                this.searchProviderFields,
                [fieldName])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {

                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


class SnapshotAccrualBrandSearchByListSearchProfile
    implements  ISearchProfile {

    aSearchProvider: ISearchProvider = undefined

    profileId = "default"
    profileName = "Brand"
    renderOptions = { ui5ResourceId: "SnapshotAccrualBrandSearchByListProfile" }

    profileFilter: IProfileFilter[] = [
        {profileFilterName: 'Brand',     searchProviderFieldId: 'BRAND_NAME', bMultiSelect: true, renderOptions: { }}
        ]

    profileDisplayFields: string[] = [
        'GLACCOUNT_NAME', "BRAND_ID", "BRAND_NAME", "PILLAR_ID", "PILLAR_NAME", "TOTAL_YTD_LIABILITY", "PREVIOUS_TOTAL_YTD_LIABILITY", "CHANGE_TOTAL_YTD_LIABILITY"
        ]
    profileTreeIdDefault = "default"
    profileTrees: ITree[] = [
        {treeId: "default",
            treeName: "By Hierarchy",
            nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Parent Set"})],
            renderOptions: {}}
    ]

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault = ""    //string;
    profileSorts: ISearchSort[] = [] //ISearchSort[];


    constructor(WB_Snapshot_Id_Curr: number, WB_Snapshot_Id_Prev: number, aSearch: ISearch){
        this.aSearchProvider = new SnapshotAccrualBrandSearchByListSearchProvider(WB_Snapshot_Id_Curr, WB_Snapshot_Id_Prev, aSearch)
    }

    get profileSearchProvider(){ return this.aSearchProvider }

}


export class SnapshotAccrualBrandSearchByList
    implements  ISearch {

    constructor(WB_Snapshot_Id_Curr: number, WB_Snapshot_Id_Prev: number, options?: any){
        this.searchProfiles = [ new SnapshotAccrualBrandSearchByListSearchProfile(WB_Snapshot_Id_Curr, WB_Snapshot_Id_Prev, this) ]
    }

    searchName = "Select Brand(s)"
    renderOptions = { ui5ResourceId: "SnapshotAccrualBrandSearchByList"}
    searchProfileIdDefault = "default"
    searchProfiles: ISearchProfile[] = []
    autoSearch = false

}
